// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tag {
    background-color: var(--palette-gray-separator);
    border-radius: 4px;
    color: var(--palette-gray-8);
    display: inline-block;
    font-size: 1rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    height: 1.42857rem;
    line-height: 1rem;
    padding: 3px 5px;
    text-transform: uppercase;
    width: auto;
    text-align: center;
}

.Tag.Tag--primary {
    color: white;
    background-color: var(--palette-trovit-blue);
}
.Tag.Tag--red {
    color: white;
    background-color: var(--palette-thribee-red);
}
.Tag.Tag--green {
    color: white;
    background-color: var(--palette-thribee-green);
}

.TagDisabled .Rectangle {
    background-color: rgba(255, 255, 255, 0);
}
.TagDisabled .UNDERDELIVERY {
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/Tag/Tag.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,4CAA4C;AAChD;AACA;IACI,YAAY;IACZ,4CAA4C;AAChD;AACA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;AAC5C;AACA;AACA","sourcesContent":[".Tag {\n    background-color: var(--palette-gray-separator);\n    border-radius: 4px;\n    color: var(--palette-gray-8);\n    display: inline-block;\n    font-size: 1rem;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    letter-spacing: normal;\n    height: 1.42857rem;\n    line-height: 1rem;\n    padding: 3px 5px;\n    text-transform: uppercase;\n    width: auto;\n    text-align: center;\n}\n\n.Tag.Tag--primary {\n    color: white;\n    background-color: var(--palette-trovit-blue);\n}\n.Tag.Tag--red {\n    color: white;\n    background-color: var(--palette-thribee-red);\n}\n.Tag.Tag--green {\n    color: white;\n    background-color: var(--palette-thribee-green);\n}\n\n.TagDisabled .Rectangle {\n    background-color: rgba(255, 255, 255, 0);\n}\n.TagDisabled .UNDERDELIVERY {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
